import 'semantic-ui-css/semantic.min.css'
import 'react-image-crop/dist/ReactCrop.css'
import 'rc-time-picker/assets/index.css'
import React, { Component } from 'react'
import { Provider } from 'react-redux'
import configureStore from './config/store'
import MainLayout from './layouts/MainLayout'
import RequireAuthenticate from './containers/requireAuthenticate'
import Detector from './components/common/Detector'
import './App.css'

const store = configureStore()

class App extends Component {
  state = { connection: window.navigator.onLine }

  onConnectionChange = connection => {
    if (connection) {
      window.location.reload()
      return
    }

    this.setState({ connection: false })
  }

  routes = () => {
    const { connection } = this.state

    return <MainLayout connection={connection} />
  }

  renderContent = () => {
    return (
      <div className="App">
        <RequireAuthenticate>{this.routes()}</RequireAuthenticate>
      </div>
    )
  }

  render() {
    return (
      <Provider store={store}>
        <Detector
          render={({ online }) => this.renderContent(online)}
          onChange={connection => this.onConnectionChange(connection)}
        />
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js